<template>
  <div>
    <b-modal
      class="modal-create-attendance"
      id="modal-create-attendance"
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      size="s"
      title="Create New Attendance"
    >
      <div>
        <b-form-group
          label="Target"
        >
          <b-form-input v-model="form.target" placeholder="Enter target" type="number"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Month(s)"
        >
          <custom-select
            placeholder="Select Month"
            v-model="selectedMonth"
            :options="months"
          />
        </b-form-group>
        <b-form-group
          label="Year"
        >
        <b-form-input v-model="currentYear" placeholder="Enter year" type="number"></b-form-input>
        </b-form-group>
      </div>
      <div>
        <b-button variant="warning" class="mt-1 text-white" block @click="create">
          Create
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        year: '',
        month: '',
        target: ''
      },
      currentYear: new Date().getFullYear(),
      selectedMonth: [],
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      status: []
    }
  },
  methods: {
    create() {
      this.form.month = this.selectedMonth
      this.form.year = this.currentYear
      this.$emit('create', this.form)
      this.form = {
        year: '',
        month: '',
        target: ''
      }
      this.$bvModal.hide('modal-create-attendance')
    }
  }
}
</script>
